import { Component } from '@angular/core';

@Component({
  selector: 'rt-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.less'],
  standalone: true,
})
export class DrawerComponent {}
